<template>
  <div class="home">
    <div class="home_body1">
      <div class="pdf_box">
        <div class="home_tit" v-if="authjson.authjson(['1-1'])">
          {{ $t("main.text251") }}
        </div>
        <!-- <el-button class="d_pdf" @click="download_pdf" size="medium">{{$t('main.text779')}}</el-button> -->
        <el-button
          v-if="authjson.authjson(['1-2']) && kyc_status == 4"
          class="d_pdf"
          @click="open_download_pdf"
          size="medium"
          >{{ $t("main.text779") }}</el-button
        >
      </div>

      <div class="home_body1_1" v-if="authjson.authjson(['1-1'])">
        <div class="h_b_box box_width1">
          <div class="body1_tit1">{{ $t("main.text252") }}</div>
          <div class="body1_tit2">
            {{ home_data.kyc_bank_info.company_name }}
          </div>
        </div>
        <div class="h_b_box box_width2">
          <div class="body1_tit1">{{ $t("main.text253") }}</div>
          <div class="body1_tit2">
            {{ home_data.kyc_bank_info.account_number }}
          </div>
        </div>
        <!-- <div class="h_b_box box_width3">
          <div class="body1_tit1">{{$t('main.text254')}}</div>
          <div class="body1_tit2">{{home_data.kyc_bank_info.referral_code}}</div>
        </div> -->

        <div class="h_b_box box_width2">
          <div class="body1_tit1">
            {{ $t("main.text474") }}
            <el-popover
              placement="top"
              popper-class="home_pop"
              width="392"
              trigger="hover"
            >
              <i slot="reference" class="el-icon-question wenhao"></i>
              <div class="home_pop_body">
                {{ $t("main.text472") }}
                {{ home_data.kyc_bank_info.deposit_code }}
                {{ $t("main.text473") }}
              </div>
            </el-popover>
          </div>
          <div class="body1_tit2">
            {{ home_data.kyc_bank_info.deposit_code }}
          </div>
        </div>
      </div>
    </div>

    <div class="home_body2" v-if="authjson.authjson(['1-4'])">
      <div class="home_tit">{{ $t("main.text255") }}</div>
      <div class="home_row">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="12" :lg="8">
            <div class="h_box">
              <div>
                <img
                  class="h_box2"
                  src="../../assets/img/home_icon1.png"
                  alt=""
                />
              </div>
              <div class="balance_box">
                <div>
                  <div class="h_box3">{{ $t("main.text40") }}</div>
                  <div class="h_box4">
                    {{ set_num3_2(home_data.usdt_balance_total) }}
                  </div>
                </div>
                <!-- <div>
                  <div class="h_box3">可用余额</div>
                  <div class="h_box4">{{home_data.usdt_balance}}</div>
                </div> -->
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="8">
            <div class="h_box">
              <div>
                <img
                  class="h_box2"
                  style="opacity: inherit"
                  src="../../assets/img/home_icon2.png"
                  alt=""
                />
              </div>
              <div class="balance_box">
                <div>
                  <div class="h_box3">{{ $t("main.text41") }}</div>
                  <div class="h_box4">
                    {{ set_num3_2(home_data.usdc_balance_total) }}
                  </div>
                </div>
                <!-- <div>
                  <div class="h_box3">可用余额</div>
                  <div class="h_box4">{{home_data.usdc_balance}}</div>
                </div> -->
              </div>
            </div>
          </el-col>
          <!-- 08-17 暂时拿掉 -->
          <!-- <el-col  :xs="24" :sm="8" :md="8" :lg="8">
            <div class="h_box">
              <div><img class="h_box2" style="opacity: inherit;" src="../../assets/img/home_icon3.png" alt=""></div>
              <div class="h_box3">{{$t('main.text44')}}</div>
              <div class="h_box4">{{home_data.eth_balance}}</div>
            </div>
          </el-col> -->
        </el-row>
      </div>
      <div class="home_row">
        <el-row :gutter="20">
          <!-- 08-17 暂时拿掉 -->
          <!-- <el-col  :xs="24" :sm="8" :md="8" :lg="8">
            <div class="h_box">
              <div><img class="h_box2" src="../../assets/img/home_icon4.png" alt=""></div>
              <div class="h_box3">{{$t('main.text45')}}</div>
              <div class="h_box4">{{home_data.btc_balance}}</div>
            </div>
          </el-col> -->

          <!-- <el-col  :xs="24" :sm="8" :md="8" :lg="8">
            <div class="h_box h_box_green">
              <div><img class="h_box2" src="../../assets/img/home_icon5.png" alt=""></div>
              <div class="h_box3">{{$t('main.text43')}}</div>
              <div class="h_box4">{{home_data.sgd_balance}}</div>
            </div>
          </el-col>
          <el-col  :xs="24" :sm="8" :md="8" :lg="8">
            <div class="h_box h_box_green">
              <div><img class="h_box2" src="../../assets/img/home_icon6.png" alt=""></div>
              <div class="h_box3">{{$t('main.text42')}}</div>
              <div class="h_box4">{{home_data.usd_balance}}</div>
            </div>
          </el-col> -->
        </el-row>
      </div>

      <!-- <div class="home_row">
        <el-row :gutter="20">
          <el-col  :xs="24" :sm="8" :md="8" :lg="8">
            <div class="h_box h_box_green">
              <div><img class="h_box2" src="../../assets/img/home_icon7.png" alt=""></div>
              <div class="h_box3">{{$t('main.text475')}}</div>
              <div class="h_box4">{{home_data.cny_balance}}</div>
            </div>
          </el-col>
          <el-col  :xs="24" :sm="8" :md="8" :lg="8">
            <div class="h_box h_box_green">
              <div><img class="h_box2" src="../../assets/img/home_icon8.png" alt=""></div>
              <div class="h_box3">{{$t('main.text476')}}</div>
              <div class="h_box4">{{home_data.gbp_balance}}</div>
            </div>
          </el-col>
          <el-col  :xs="24" :sm="8" :md="8" :lg="8">
            <div class="h_box h_box_green">
              <div><img class="h_box2" src="../../assets/img/home_icon9.png" alt=""></div>
              <div class="h_box3">{{$t('main.text477')}}</div>
              <div class="h_box4">{{home_data.aud_balance}}</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="home_row">
        <el-row :gutter="20">
          <el-col  :xs="24" :sm="8" :md="8" :lg="8">
            <div class="h_box h_box_green">
              <div><img class="h_box2" src="../../assets/img/home_icon10.png" alt=""></div>
              <div class="h_box3">{{$t('main.text478')}}</div>
              <div class="h_box4">{{home_data.hkd_balance}}</div>
            </div>
          </el-col>
        </el-row>
      </div> -->
    </div>

    <!-- 卡片组件 -->
    <CardBox v-if="authjson.authjson(['1-3'])">
      <!-- <div slot="card_title" class="home_tit">{{$t("bank_card.FEB_Debit_Cards")}}</div> -->
    </CardBox>

    <footer>
      <div>
        ©️ 2021 - {{ new Date().getFullYear() }} FEB Corporation. Registration
        ID: 2013/C2892
      </div>
      <div>
        <span @click="LinkTo('https://finexteasternbank.com/terms-of-use/')">
          Terms of Use
        </span>
        ｜
        <span @click="LinkTo('https://finexteasternbank.com/privacy-policy/')">
          Privacy Policy
        </span>
        ｜
        <span
          @click="
            LinkToPdf(
              'https://data-storage-d3.s3.ap-southeast-1.amazonaws.com/autonym/offical/Terms_and_Conditions_Governing_AccountsV1.pdf'
            )
          "
        >
          Terms & Conditions
        </span>
      </div>
    </footer>

    <!-- 欢迎使用 -->
    <el-dialog
      :visible.sync="welcome_dlg"
      custom-class="welcome_dlg_height"
      append-to-body
      center
      width="710px"
    >
      <div class="log_out2">
        {{ $t("main.text46") }}
      </div>
      <div class="log_out3">
        {{ $t("main.text47") }}
      </div>
      <div class="welcome_main">
        <div class="w_main">
          <div class="w_main_two">
            <div class="w_main1">
              <img src="../../assets/img/welcome_img1.png" alt="" />
            </div>
            <div class="w_main2">
              <div class="w_main_t1">{{ $t("main.text51") }}</div>
              <div class="w_main_t2">{{ $t("main.text52") }}</div>
              <div>
                <el-button class="w_main_btn" @click="$router.push('/kyc')">{{
                  $t("main.text53")
                }}</el-button>
              </div>
            </div>
          </div>
          <div class="text_b">
            <div class="text_b_t1">{{ $t("main.text54") }}</div>
            <div class="text_b_t2">
              <i class="el-icon-check icon_check"></i>{{ $t("main.text55") }}
            </div>
            <div class="text_b_t2">
              <i class="el-icon-check icon_check"></i>{{ $t("main.text56") }}
            </div>
            <div class="text_b_t2">
              <i class="el-icon-check icon_check"></i>{{ $t("main.text57") }}
            </div>
            <div v-if="text_show">
              <div class="text_b_t2">
                <i class="el-icon-check icon_check"></i>{{ $t("main.text58") }}
              </div>
              <div class="text_b_t2">
                <i class="el-icon-check icon_check"></i>{{ $t("main.text59") }}
              </div>
              <div class="text_b_t2">
                <i class="el-icon-check icon_check"></i>{{ $t("main.text60") }}
              </div>
              <div class="text_b_t2">
                <i class="el-icon-check icon_check"></i>{{ $t("main.text61") }}
              </div>
              <div class="text_b_t2">
                <i class="el-icon-check icon_check"></i>{{ $t("main.text62") }}
              </div>
              <div class="text_b_t2">
                <i class="el-icon-check icon_check"></i>{{ $t("main.text247") }}
              </div>
            </div>
            <div class="text_b_t3" @click="text_show = !text_show">
              <span v-if="text_show">{{ $t("main.text64") }}</span>
              <span v-else>{{ $t("main.text249") }}</span>
            </div>
          </div>
        </div>

        <div class="w_main">
          <div class="w_main_two">
            <div class="w_main1">
              <img src="../../assets/img/welcome_img2.png" alt="" />
            </div>
            <div class="w_main2">
              <div class="w_main_t1">{{ $t("main.text48") }}</div>
              <div class="w_main_t2">{{ $t("main.text49") }}</div>
              <div>
                <el-button class="w_main_btn" @click="router_kf">{{
                  $t("main.text53")
                }}</el-button>
              </div>
            </div>
          </div>
        </div>

        <div class="text_btm">
          <span @click="welcome_dlg = false">{{ $t("main.text65") }}</span>
        </div>
      </div>
    </el-dialog>

    <div class="download_pdf_box pdf_location">
      <PDF1 :dataList="pdf1List" :y="y" :m="m" :days="days" />
      <PDF2
        :dataList="pdf2List"
        :usdcResult="usdcResult"
        :usdtResult="usdtResult"
      />
      <div class="pdf-header">
        <div class="pdf-header1">
          <img src="../../assets/img/pdf_logo.png" alt="" />
        </div>
        <div class="pdf-header2">
          <div>
            <span> {{ pdf1List.company_name }} </span>
            <span v-if="v_lan != 'ch'"
              >Statement Period {{ days }} {{ m | current_month }} {{ y }}</span
            >
            <span v-else> 结单期 {{ y }}-{{ m }}-{{ days }} </span>
            <span class="pdf-header2-span spanNoBorder"></span>
          </div>
        </div>
      </div>
      <div class="pdf-footer">
        <div class="pdf-footer-div" style="padding-top: 5px">
          <div class="left">
            <p>{{ $t("pdf.text43") }} |</p>
            <p>{{ $t("pdf.text44") }}</p>
          </div>
          <div class="right">
            <p>{{ $t("pdf.text45") }} |</p>
            <p>www.finexteasternbank.com</p>
          </div>
          <!-- <div
            class="rotate"
            v-text="'FEB<account number>SOA0012212XDSW'"
          ></div> -->
        </div>
      </div>
    </div>

    <!-- pdf 弹框 -->
    <el-dialog
      :title="$t('main.text780')"
      :visible.sync="pdf_dlg"
      custom-class="dlg element_input card_dlg"
      append-to-body
      width="750px"
    >
      <div class="dlg_body">
        <div class="pdf_body">
          <div class="p_item" v-for="(item, index) in dateList" :key="index">
            <div>
              <div class="p_t1" v-if="v_lan != 'ch'">
                {{ item.Month | current_month }} {{ item.Year }}
              </div>
              <div class="p_t1" v-else>
                {{ item.Year }} 年 {{ item.Month }} 月
              </div>
              <div class="p_t2">{{ $t("main.text781") }}</div>
            </div>
            <div>
              <img
                @click="download_pdf(item.Year, item.Month)"
                class="p_icon"
                src="../../assets/img/pdf_icon.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  home,
  kyc_submit,
  accountStatement,
  accountDetails,
  getUserInfo,
} from "@/api/api";
import CardBox from "../../component/card";
import PDF1 from "../pdf/pdf1.vue";
import PDF2 from "../pdf/pdf2.vue";

import { outputPDF } from "../../utils/outputPDF";
import axios from "axios";
export default {
  filters: {
    current_month(v) {
      let en_mon_arr = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      return en_mon_arr[v - 1];
    },
  },
  components: {
    CardBox,
    PDF2,
    PDF1,
  },
  data() {
    return {
      pdfUrl:
        "https://data-storage-d3.s3.ap-southeast-1.amazonaws.com/autonym/offical/Terms_and_Conditions_Governing_AccountsV1.pdf",
      home_data: {
        box_status: "",
        btc_balance: "",
        eth_balance: "",
        kyc_bank_info: {
          account_number: "",
          bank_name: "",
          referral_code: "",
        },
        sgd_balance: "",
        usd_balance: "",
        usdc_balance: "",
        usdt_balance: "",
      },
      welcome_dlg: false,
      text_show: false,
      pdf_dlg: false,
      dateList: [],
      pdf1List: {},
      pdf2List: [],
      usdcResult: [],
      usdtResult: [],
      y: "",
      m: "",
      days: "",
      kyc_status: 0,
      kycApproveTime: "",
    };
  },
  async beforeMount() {
    await this.get_user_info();
  },
  mounted() {
    this.get_list();
    // --
    // let date = new Date();
    // let Year = date.getFullYear();
    // let Month = date.getMonth() + 1;
    // let dateList = [];
    // for (let i = 0; i < 6; i++) {
    //   Month--;
    //   if (Month == 0) {
    //     Month = 12;
    //     Year = Year - 1;
    //   }
    //   dateList.push({ Year, Month });
    // }
    // this.dateList = dateList;
    // --
  },
  methods: {
    LinkToPdf(v) {
      axios.get(v, { responseType: "blob" }).then((data) => {
        let responseData = data.data;
        let blob = new Blob([responseData], {
          type: "application/pdf;charset=utf-8",
        });
        const href = URL.createObjectURL(blob);
        window.open(href, "newWindow");
      });
    },
    LinkTo(v) {
      window.open(v, "_blank");
    },
    get_list() {
      home().then((res) => {
        if (res.data.code == 200) {
          this.home_data = res.data.data;

          // box_status: 0 弹窗 1 不弹窗
          if (res.data.data.box_status == 0) {
            this.welcome_dlg = true;
          } else {
            this.welcome_dlg = false;
          }
          // console.log(res.data.data);
        }
      });
    },
    router_kf() {
      this.welcome_dlg = false;
      kyc_submit().then((res) => {
        if (res.data.code == 200) {
          // this.$router.push('/user_info');
          this.bus.$emit("kf_dlg");
        } else {
          // this.$message.closeAll();
          // this.$message.error(res.data.msg);
          this.message.ismessage("error", res.data.msg);
        }
      });
    },
    async download_pdf(y, m) {
      this.y = y;
      this.m = m;
      this.days = new Date(y, m, 0).getDate();
      await accountStatement({
        year: this.y,
        month: this.m,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pdf1List = res.data.data;
          // console.log(res.data.data);
        } else {
          this.$message.error(res.data.msg);
        }
      });

      await accountDetails({
        year: this.y,
        month: this.m,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pdf2List = res.data.data;
          this.usdcResult = res.data.data.usdcResult;
          this.usdtResult = res.data.data.usdtResult;
        } else {
          this.$message.error(res.data.msg);
        }
      });
      const element = document.querySelector(".download_pdf_box");
      const header = document.querySelector(".pdf-header");
      const footer = document.querySelector(".pdf-footer");
      try {
        // 这个pdf的文件名  需要改成这种格式：10102416770-DA-202401
        // 第一串数字是这个账号的Account Number  ;DA是固定的字母；后面是年份和月份
        let m_time = this.m<10?'0'+this.m:this.m;
        let filename = `${this.pdf1List.account_number}-DA-${this.y}${m_time}.pdf`
        await outputPDF({
          element: element,
          footer: footer,
          header: header,
          contentWidth: 560,
          filename,
        });
      } catch (error) {
        this.$message.error(
          typeof error === "string" ? error : JSON.stringify(error)
        );
      }
    },
    open_download_pdf() {
      this.pdf_dlg = true;
    },

    get_user_info() {
      getUserInfo().then((res) => {
        if (res.data.code == 200) {
          // kyc_status: KYC状态 0没有 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败
          // 4审核通过 路由才能跳转
          // sessionStorage.setItem("kyc_status", res.data.data.kyc_status);
          this.kyc_status = res.data.data.kyc_status;

          // FEB login 和 getUserInfo 新增kycApproveTime，通过的时间 根据这个时间和现在的时间 推断 显示哪几个月可下载
          this.kycApproveTime = res.data.data.kycApproveTime;
          // console.log(this.overall_time2(this.kycApproveTime));

          const d_time = new Date().getTime();
          if (d_time > this.kycApproveTime) {
            let my_month = Math.floor(
              (d_time - this.kycApproveTime) / 1000 / 60 / 60 / 24 / 30
            );
            // console.log(my_month);
            let date = new Date();
            let Year = date.getFullYear();
            let Month = date.getMonth() + 1;
            let dateList = [];
            let for_num = 0;
            if (my_month >= 6) {
              for_num = 6;
            } else {
              for_num = my_month;
            }
            for (let i = 0; i < for_num; i++) {
              // 没有9月  9月还没过完
              Month--;
              if (Month == 0) {
                Month = 12;
                Year = Year - 1;
              }
              dateList.push({ Year, Month });
            }
            this.dateList = dateList;
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
footer {
  padding-top: 50px;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  span {
    cursor: pointer;
  }
}
/* 滚动条 */
/* .home {
  overflow-y: auto;
  height: calc(100vh - 80px);
}
.home::-webkit-scrollbar {
  width: 5px;
}
.home::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #687eec;
} */
/* --over-- */
// .rotate {
//   position: fixed;
//   top: 800px;
//   left: -140px;
//   transform: rotate(270deg);
// }
.pdf-footer {
  width: 1000px;
  position: fixed;
  top: -100vh;

  .pdf-footer-div {
    display: flex;
    justify-content: space-between;
    margin: 20px 60px;
  }
}
.pdf-header {
  width: 1000px;
  position: fixed;
  top: -100vh;
  .pdf-header1 {
    margin: 20px 60px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    img {
      width: 150px;
    }
  }
  .pdf-header2 {
    margin-right: 60px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    div {
      display: inline-block;
      border: 1px solid black;
      border-radius: 5px;
      span {
        border-right: 1px solid black;
        padding: 0 5px;
        margin: 5px 0;
        display: inline-block;
        font-size: 15px;
      }
      .spanNoBorder {
        border: none;
      }
    }
  }
}
.h_box {
  background: #04182a;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px;
  color: #fff;
  min-height: 214px;
}
.home_row {
  margin-bottom: 20px;
}
.h_box2 {
  max-height: 60px;
  opacity: 0.2;
}
.h_box3 {
  font-size: 15px;
  margin-top: 25px;
  margin-bottom: 12px;
}
.h_box4 {
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
}

/* 退出弹框 */
.log_out1 img {
  width: 40px;
  display: block;
  margin: auto;
}
.log_out2 {
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  text-align: center;
  color: #ffffff;
  /* margin-top: 16px; */
}
.log_out3 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  color: #ffffff;
  opacity: 0.8;
  margin-top: 8px;
  text-align: center;
  box-sizing: border-box;
  padding: 0 75px;
  word-break: break-word;
  word-wrap: break-word;
}
.cancel_btn {
  color: #f1c788;
  border-color: #f1c788;
  background: transparent;
}
.confirm_btn {
  width: 163px;
  height: 38px;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  border-color: #f1c788;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  text-align: center;
  color: #04182a;
  /* margin-left: 20px; */
  margin-bottom: 15px;
}
.do_it_later {
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  text-decoration-line: underline;
  color: #deb981;
  text-align: center;
  cursor: pointer;
  margin-bottom: 15px;
}
/* --over-- */
.welcome_main {
  box-sizing: border-box;
  padding: 40px;
  color: #fff;
  padding-bottom: 0;
}
.w_main {
  box-sizing: border-box;
  padding: 20px;
  background: #04182a;
  border-radius: 16px;
  margin-bottom: 20px;
}
.w_main_two {
  display: flex;
  background: #04182a;
  align-items: center;
}

.w_main1 img {
  width: 218px;
  border-radius: 16px;
  margin-right: 15px;
}
.w_main_t1 {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  /* line-height: 26px; */
  margin-bottom: 8px;
  word-break: break-word;
  word-wrap: break-word;
}
.w_main_t2 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  opacity: 0.8;
  margin-bottom: 16px;
  word-break: break-word;
  word-wrap: break-word;
}
.w_main_btn,
.w_main_btn:hover {
  min-width: 160px;
  height: 38px;
  line-height: 38px;
  padding: 0;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  border-color: #f1c788;
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  text-align: center;
  color: #04182a;
}
.text_b {
  border-top: 1px solid #404f5d;
  margin-top: 16px;
  box-sizing: border-box;
  padding-top: 16px;
}
.text_b_t1 {
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  margin-bottom: 10px;
}
.text_b_t2 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  opacity: 0.8;
  margin-bottom: 6px;
}
.text_b_t3 {
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  color: #deb981;
  cursor: pointer;
}
.icon_check {
  margin-right: 6px;
}
.text_btm {
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  text-decoration-line: underline;
  color: #deb981;
}
.text_btm span {
  cursor: pointer;
}
.home_tit {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 16px;
}
.home_body1_1 {
  background: #04182a;
  border-radius: 16px;
  /* margin: 28px; */
  box-sizing: border-box;
  padding: 28px;
  display: flex;
  // margin-bottom: 60px;
  margin-bottom: 30px;
}
.body1_tit1 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  opacity: 0.6;
  margin-bottom: 8px;
}
.body1_tit2 {
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 20px;
}
.h_b_box {
  padding-right: 28px;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  padding-left: 28px;
}
.home_body1_1 .h_b_box:last-child {
  border-right: none;
  padding-right: 0;
}
.home_body1_1 .h_b_box:first-child {
  padding-left: 0;
}
.box_width1 {
  min-width: 257px;
}
.box_width2 {
  min-width: 111px;
}
.box_width3 {
  min-width: 88px;
}
/* ------ */
.h_box_green .h_box2 {
  opacity: 0.3;
}
.h_box_green .h_box3 {
  color: rgba(18, 186, 156, 0.8);
}
.h_box_green .h_box4 {
  color: rgba(18, 186, 156, 1);
}
.h_box_green .h_box2 {
  max-height: 48px;
}

.balance_box {
  display: flex;
  justify-content: space-between;
}
.pdf_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.pdf_box .home_tit {
  margin-bottom: 0;
}
.d_pdf {
  color: #deb981;
  border: 1.5px solid #deb981;
  background: transparent;
}
.pdf_body {
  box-sizing: border-box;
  padding: 40px 50px;
}
.dlg_body {
  border-radius: 0 0 16px 16px;
}
.p_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #314b69;
  padding-bottom: 15px;
  margin-bottom: 15px;
  color: #fff;
}
.p_t1 {
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 5px;
}
.p_t2 {
  font-weight: 400;
  font-size: 13px;
  opacity: 0.6;
}
.p_icon {
  width: 20px;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 5px;
}
.pdf_location {
  color: #000;
  position: fixed;
  top: 0;
  left: 0;
  transform: translateX(-100%);
  background: #fff;
  z-index: 2;
  width: 900px;
}
</style>
<style>
.welcome_dlg_height {
  /* background: #041E35 !important; */
  background: url("../../assets/img/welcome_dlg_bgc.png") no-repeat #041e35 !important;
  /* background-size: cover; */
  background-size: 100% 100% !important;
  color: #fff;
  border-radius: 16px;
}
.welcome_dlg_height .el-dialog__header {
  padding: 0 !important;
}
.welcome_dlg_height .el-dialog__headerbtn {
  text-align: right !important;
  width: 94%;
  display: inline-block;
}
.welcome_dlg_height .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
@media screen and (max-height: 747px) {
  .welcome_dlg_height {
    left: 50%;
    top: 0;
    transform: translate(-50%, 0);
    margin: 50px 0 !important;
  }
}
.wenhao {
  margin-left: 6px;
  cursor: pointer;
}
</style>

<style scoped>
/* 平板 */
@media screen and (min-width: 768px) and (max-width: 1200px) {
}
/* 手机  850 */
@media screen and (max-width: 767px) {
  .log_out3 {
    padding: 0;
  }
  .welcome_main {
    padding: 0;
  }
  .w_main_two {
    display: block;
  }
  .w_main_t1 {
    margin-top: 10px;
  }
  .h_box {
    margin-bottom: 15px;
  }
  .home_row {
    margin-bottom: 0;
  }
  .home_body1_1 {
    display: inherit;
  }
  .box_width1,
  .box_width2,
  .box_width3 {
    min-width: 100%;
  }
  .h_b_box {
    padding: 0;
    border: none;
  }
  footer {
    display: inline-block;
  }
  footer div {
    display: flex;
    justify-content: center;
    padding-top: 10px;
  }
}
</style>